import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import localeFr from '@angular/common/locales/fr';

import { AppComponent } from './app.component';
import { AuthentificationComponent } from './authentification/authentification.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalErrorHandler } from './_shared/_helpers/global-error.handler';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxTextBoxModule, DxDateBoxModule, DxSelectBoxModule, DxNumberBoxModule, DxButtonModule, DxTextAreaModule, DxCheckBoxModule, DxTooltipModule, DxTemplateModule, DxTagBoxModule, DxValidatorModule, DxValidationSummaryModule, DxFormModule, DxChartModule } from 'devextreme-angular';
// import { FileUploadModule } from 'ng2-file-upload';
import { DatagridModule } from './datagrid/datagrid.module';
import { SharedModule } from './_shared/shared.module';
import { OptimizationModule } from './_shared/optimization.module';
import { AppRoutingModule } from './app-routing.module';
import { DatePipe, registerLocaleData } from '@angular/common';
import { ErrorInterceptor } from './_shared/_helpers/error.interceptor';
import { JwtInterceptor } from './_shared/_helpers/jwt.interceptor';
import { DxiButtonModule } from 'devextreme-angular/ui/nested';
import { AuthentificationFormloginComponent } from './authentification/formlogin/formlogin.component';
import { AuthentificationFormpasswordComponent } from './authentification/formpassword/formpassword.component';
import { AuthentificationFormsigninComponent } from './authentification/formsignin/formsignin.component';
import { FormverifyComponent } from './authentification/formverify/formverify.component';
import { locale } from "devextreme/localization"
import { PagesModule } from './_pages/pages.module';
import { AuthGuard } from './_shared/_guard/auth.guard';
import { AdminSharedModule } from './admin/_shared/shared.module';
import { AdminPageModule } from './admin/admin.module';
import { AuthenticationService } from './_shared/_services/authentication.service';
// import { FlickityModule } from 'ngx-flickity';
import { ForumModule } from './_forum/forum.module';
import { NgxQrcodeStylingModule } from 'ngx-qrcode-styling';
import { YoutubePlayerComponent } from 'ngx-youtube-player';
registerLocaleData(localeFr);
locale('fr')

@NgModule({
  declarations: [
    AppComponent,
    AuthentificationComponent,
    AuthentificationFormloginComponent,
    AuthentificationFormpasswordComponent,
    AuthentificationFormsigninComponent,
    FormverifyComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    // ServicesModule,
    SharedModule,
    AdminSharedModule,
    // Suppression des modules chargés en lazy loading
    // PagesModule,
    // ForumModule,
    // AdminPageModule,
    HttpClientModule,
    // FileUploadModule,
    // Regroupement des modules DevExtreme
    DxTextBoxModule, 
    DxDateBoxModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxTextAreaModule,
    DxiButtonModule,
    DxTooltipModule,
    DxTemplateModule,
    DxTagBoxModule,
    DxValidatorModule,
    DxValidationSummaryModule,
    DxFormModule,
    // FlickityModule,
    DxChartModule,
    NgxQrcodeStylingModule,
    YoutubePlayerComponent,
    OptimizationModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: "fr-FR",
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
